import React from 'react';
import PropTypes from 'prop-types';

import RootStore from 'RootStore';

import {
    changeAmount,
    deleteProduct,
} from '../actions';

const AmountChanger = ({ productSlug, amount }) => {
    const store = RootStore.getStore();

    const handleAddOne = () => {
        store.dispatch(
            changeAmount(productSlug, amount + 1),
        );
    };

    const handleRemoveOne = () => {
        if (amount - 1 < 0) {
            return;
        }

        store.dispatch(
            changeAmount(productSlug, amount - 1),
        );
    };

    const handleRemoveItem = (event) => {
        event.target.blur();

        store.dispatch(
            deleteProduct(productSlug),
        );
    };

    return (
        <div className="amount-changer-container">
            <div className="amount-changer">
                <button className="amount-changer__button" onClick={handleRemoveOne}>
                    -
                </button>
                <span className="amount-changer__value">{amount}</span>
                <button className="amount-changer__button" onClick={handleAddOne}>
                    +
                </button>
            </div>
            <button className="remove-button" onClick={handleRemoveItem}>&times;</button>
        </div>
    );
};

AmountChanger.propTypes = {
    productSlug: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
};

export default AmountChanger;



// WEBPACK FOOTER //
// ./resources/components/shop/components/AmountChanger.jsx